import { 
    LOAD_LIST_MEDICINE, LOAD_A_MEDICINE, ADD_NEW_MEDICINE, UPDATE_A_MEDICINE, 
    DELETE_A_MEDICINE, CLEAR_A_MEDICINE_DETAIL, CLEAR_MEDICINE_ACTION_STATUS,
    LOAD_LIST_MEDICINE_IMPORT_EXPORT, UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT,
    DOC_EXPORT_MEDICINE_LIST_TO_CSV, DOC_EXPORT_MEDICINE_LIST_TO_EXCEL, CLEAR_MEDICINE_LIST_REMOTE_CSV, CLEAR_MEDICINE_LIST_REMOTE_EXCEL
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';
import { cloneDeep } from "lodash";

const initialState = {
    medicineList: [],
    medicineDetail: null,
    medicineImportExportList: [],
    totalCount: 0,
    limit: 10,
    offset: 0,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: "",
    remoteCSV: null,
    remoteEXCEL: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_MEDICINE: {
            const { result, totalCount, limit, offset } = action.payload;
            
            return {
                ...state,
                medicineList: result,
                totalCount,
                limit, 
                offset
            }
        }

        case LOAD_A_MEDICINE: {
            return {
                ...state,
                medicineDetail: action.payload
            }
        }

        case ADD_NEW_MEDICINE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                medicineList: [
                    action.payload.data,
                    ...state.medicineList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_MEDICINE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                medicineList: state.medicineList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_MEDICINE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                medicineList: state.medicineList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_MEDICINE_DETAIL: {
            return {
                ...state,
                medicineDetail: null,
            }
        }

        case CLEAR_MEDICINE_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        case LOAD_LIST_MEDICINE_IMPORT_EXPORT: {
            return {
                ...state,
                medicineImportExportList: action.payload
            }
        }

        case UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            let updateMedicineList = cloneDeep(state.medicineList);
            let findUpdateMedicineIdx = updateMedicineList.findIndex(item => item.id === parseFloat(action.payload.data.medicine_id));
            if(findUpdateMedicineIdx !== -1) {
                if(action.payload.data.isImport) {
                    updateMedicineList[findUpdateMedicineIdx].quantity += parseFloat(action.payload.data.quantity);
                } else {
                    updateMedicineList[findUpdateMedicineIdx].quantity -= parseFloat(action.payload.data.quantity);
                }
            }

            return {
                ...state,
                medicineList: updateMedicineList,
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DOC_EXPORT_MEDICINE_LIST_TO_CSV.SUCCESS:
            return {
                ...state,
                remoteCSV: action.payload,
            };

        case CLEAR_MEDICINE_LIST_REMOTE_CSV: {
            return {
                ...state,
                remoteCSV: null,
            };
        }

        case DOC_EXPORT_MEDICINE_LIST_TO_EXCEL.SUCCESS:
            return {
                ...state,
                remoteEXCEL: action.payload,
            };

        case CLEAR_MEDICINE_LIST_REMOTE_EXCEL: {
            return {
                ...state,
                remoteEXCEL: null,
            };
        }

        default:
            return state
    }
}